import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    create_pay_record(args) {
        return axios.post(`${apiUrl}v2/create_pay_record/`, {params: args})
    },
    create_expense_record(args) {
        return axios.post(`${apiUrl}v2/create_expense_record/`, {params: args})
    },
    get_login_user_coin_count(args) {
        return axios.get(`${apiUrl}v2/get_login_user_coin_count/`, {params: args})
    },
    get_login_user_expense_record(args) {
        return axios.get(`${apiUrl}v2/get_login_user_expense_record/`, {params: args})
    },
    get_login_user_pay_record(args) {
        return axios.get(`${apiUrl}v2/get_login_user_pay_record/`, {params: args})
    },
    get_pay_mode(args) {
        return axios.get(`${apiUrl}v2/get_pay_mode/`, {params: args})
    },
    alipay_form_generate_values(args) {
        return axios.post(`${apiUrl}v2/alipay_form_generate_values/`, {params: args})
    },
    generate_wxpay_code_url(args){
        return axios.post(`${apiUrl}v2/generate_wxpay_code_url/`, {params: args})
    },
    pay_success_confirm(args){
         return axios.get(`${apiUrl}v2/pay_success_confirm/`, {params: args})
    }

}
